import { combineReducers } from '@reduxjs/toolkit';
import settingsSlice from './slices/settings';
import servicesSlice from './slices/services';
import userSlice from './slices/user';
import requestsSlice from './slices/requests';
import formsSlice from './slices/forms';
import companySlice from './slices/company';
import revisionsSlice from './slices/revisions';
import vehicleSlice from './slices/vehicle';
import surveySlice from './slices/survey';
import lineSlice from './slices/line';
import licenseSlice from './slices/license';
import manualsSlice from './slices/manuals';

const rootReducer = combineReducers({
    [settingsSlice.name]: settingsSlice.reducer,
    [servicesSlice.name]: servicesSlice.reducer,
    [userSlice.name]: userSlice.reducer,
    [requestsSlice.name]: requestsSlice.reducer,
    [formsSlice.name]: formsSlice.reducer,
    [companySlice.name]: companySlice.reducer,
    [revisionsSlice.name]: revisionsSlice.reducer,
    [vehicleSlice.name]: vehicleSlice.reducer,
    [surveySlice.name]: surveySlice.reducer,
    [lineSlice.name]: lineSlice.reducer,
    [licenseSlice.name]: licenseSlice.reducer,
    [manualsSlice.name]: manualsSlice.reducer,
});

export default rootReducer;
